import React from "react";

/**
 * Logo — d-Pod Gallery.
 *
 * Two-line stacked mark:
 *   d-Pod       (main, serif, tight tracking, dark)
 *   Gallery     (subtitle, uppercase overline-style, muted)
 *
 * Variants:
 *   variant="compact"  — for nav headers (small, one-line rhythm)
 *   variant="stacked"  — for hero, footer, dashboards (large, 2-line)
 *   variant="mono"     — single-color version for print/PDF
 */
export const Logo = ({ variant = "compact", className = "" }) => {
  if (variant === "stacked") {
    return (
      <span className={`inline-flex flex-col leading-none ${className}`} data-testid="brand-logo">
        <span className="font-serif text-4xl tracking-[-0.02em] text-neutral-950">
          d-<span className="italic">Pod</span>
        </span>
        <span className="overline text-neutral-400 tracking-[0.35em] mt-2 text-[10px]">Gallery</span>
      </span>
    );
  }
  if (variant === "mono") {
    return (
      <span className={`inline-flex flex-col leading-none ${className}`}>
        <span className="font-serif text-3xl tracking-[-0.02em]">
          d-<span className="italic">Pod</span>
        </span>
        <span className="overline tracking-[0.35em] mt-1.5 text-[9px]">Gallery</span>
      </span>
    );
  }
  // compact — for navbars
  return (
    <span className={`inline-flex flex-col leading-none ${className}`} data-testid="brand-logo">
      <span className="font-serif text-xl tracking-[-0.02em] text-neutral-950">
        d-<span className="italic">Pod</span>
      </span>
      <span className="overline text-neutral-400 tracking-[0.3em] mt-0.5 text-[9px]">Gallery</span>
    </span>
  );
};

export default Logo;
